//Props Validations
import PropTypes from "prop-types";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { loadSelectedDatasetState } from "store/features/analysisResultsSlice";
const dataViewOptions = [
    { value: "concept", label: "Concept Data" },
    { value: "concept_recall", label: "Concept + Recall Data" },
    { value: "recall", label: "Recall Data" },
];
const customStyles = {
    // Wrapper container
    container: (base) => ({
        ...base,
        width: "190px",
        marginRight: "20px",
    }),
    // Main select control
    control: (base) => ({
        ...base,
        minHeight: "30px",
        height: "30px",
        border: "1px solid var(--light-blue)",
        borderRadius: "4px",
        boxShadow: "none",
        backgroundColor: "#fff",
        "&:hover": {
            border: "1px solid var(--light-blue)",
        },
    }),
    // Selected value container
    valueContainer: (base) => ({
        ...base,
        padding: "0 6px",
        fontSize: "12px",
        fontWeight: "bold",
        letterSpacing: "0.4px",
        color: "var(--color-blue)",
    }),
    // Selected option text
    singleValue: (base) => ({
        ...base,
        color: "var(--color-blue)",
        fontSize: "12px",
        fontWeight: "bold",
        letterSpacing: "0.4px",
    }),
    // Hide separator between value and dropdown icon
    indicatorSeparator: () => ({
        display: "none",
    }),
    // Dropdown arrow icon
    dropdownIndicator: (base) => ({
        ...base,
        color: "var(--color-blue)",
        padding: "0 6px",
    }),
    // Dropdown menu
    menu: (base) => ({
        ...base,
        zIndex: 9999,
    }),
    // Individual dropdown option
    option: (base, { isFocused, isSelected }) => ({
        ...base,
        fontSize: "12px",
        fontWeight: isSelected ? "bold" : 500,
        letterSpacing: "0.3px",
        color: isSelected ? "#fff" : "var(--color-blue)",
        backgroundColor: isSelected ? "var(--color-blue)" : isFocused ? "#eaf3ff" : "#fff",
        cursor: "pointer",
    }),
};
const DataViewMode = ({ clearResult = () => {} }) => {
    const dispatch = useDispatch();
    const selectedDataset = useSelector((state) => state.analysisResultsStore.selectedDataset);
    const handleChange = (selectedOption) => {
        clearResult();
        dispatch(loadSelectedDatasetState(selectedOption));
    };
    return (
        <Select
            value={selectedDataset}
            placeholder={"Data View"}
            options={dataViewOptions}
            onChange={handleChange}
            styles={customStyles}
            isSearchable={false}
        />
    );
};
DataViewMode.propTypes = {
    clearResult: PropTypes.func,
};
export default DataViewMode;